import { render, staticRenderFns } from "./CsatTable.vue?vue&type=template&id=566ba57f&scoped=true&"
import script from "./CsatTable.vue?vue&type=script&lang=js&"
export * from "./CsatTable.vue?vue&type=script&lang=js&"
import style0 from "./CsatTable.vue?vue&type=style&index=0&id=566ba57f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ba57f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566ba57f')) {
      api.createRecord('566ba57f', component.options)
    } else {
      api.reload('566ba57f', component.options)
    }
    module.hot.accept("./CsatTable.vue?vue&type=template&id=566ba57f&scoped=true&", function () {
      api.rerender('566ba57f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/components/CsatTable.vue"
export default component.exports